<template>
  <van-popup
    v-model="visible"
    position="bottom"
    round
    closeable
    close-icon="close"
    style="min-height: 40%;"
  >
    <div class="record">
      <div class="title fs_18 mt_2 bold text_center mb_12">领取记录</div>
      <div class="record_wrap">
        <van-empty
          v-if="noRecord"
          class="custom-image"
          image="https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/empty.png"
          description="暂无数据"
        />
        <div v-if="list.length" class="record_item record_title">
          <div class="record_td bold record_left">奖励名称</div>
          <div class="record_td bold record_mid">领取时间</div>
          <div class="record_td bold record_right">惊喜码</div>
        </div>
        <div class="record_list">
          <div v-for="it in list" :key="it.createTime" class="record_item">
            <div class="record_td record_left">{{ it.rewardName }}</div>
            <div class="record_td record_mid">{{ it.createTime }}</div>
            <div class="record_td record_right">
              <div>{{ it.cdk }}</div>
              <span v-if="it.cdk" v-clipboard="it.cdk" class="fs_10 text_nowrap" style="color: #2B35FF">
                <i class="iconfont yw-copy fs_10"></i>复制
              </span>
              <span class="fs_10" style="color: #FF3000" v-else>
                领取失败
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Empty } from 'vant';
import { getTransformPromoteRecord } from '@/apis/qiweiMiniGame'
import store from "@/store";
export default {
  props: {
    activityId: {
      type: String,
      default: '',
    },
    issueType: {
      type: [Number, String],
      default: '',
    },
  },
  components: {
    [Popup.name]: Popup,
    [Empty.name]: Empty,
  },
  data () {
    return {
      visible: false,
      list: [],
      noRecord: false,
    }
  },
  computed: {
  },
  watch: {
    visible (val) {
      if (!val) {
        this.$emit('close')
      }
    },
  },
  methods: {
    triggerVisible (visible) {
      this.visible = visible;
      if (visible) {
        this.getList()
      }
    },
    getList () {
      getTransformPromoteRecord({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        activityId: this.activityId,
      }).then(res => {
        this.list = res.data || []
        this.noRecord = !this.list.length
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.record {
  padding: 16px;
  .record_list {
    max-height: 320px;
    overflow: auto;
    padding: 6px 0;
    color: #616161;
    font-size: 12px;
  }
  .record_item {
    display: flex;
    align-items: center;
  }
  .record_title {
    padding-bottom: 6px;
    border-bottom: 1px #eee solid;
  }
  .record_td {
    width: 33%;
    text-align: center;
  }
  .record-title {
    padding-bottom: 12px;
    border-bottom: 1px solid #b7b7b7;
  }
  .record_item  + .record_item {
    margin-top: 16px;
  }
  .fs_10 {
    font-size: 10px;
  }
}
</style>